import { Component } from '@angular/core';
import { InfoLinks } from '@sondermind/core/enums/info-links.enum';

@Component({
  selector: 'not-in-your-state',
  templateUrl: './not-in-your-state.component.html',
  styleUrls: ['./not-in-your-state.component.scss']
})
export class NotInYourStateComponent {
  comingToYourStateLink = InfoLinks.CLIENT_COMING_TO_YOUR_STATE;
}
